var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.decimales == '00' ? 'mr-4' : ''},[_vm._v(" "+_vm._s(_vm.entero)),(_vm.decimales != '00')?_c('sup',[_vm._v(_vm._s(_vm.decimales))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }